import api from './api';
import { CalendarEventDto } from '../types/calendar';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';

export interface TaskDetails {
  notes?: string;
  priority?: 'low' | 'medium' | 'high';
}

export interface CreateTaskEventDto {
  title: string;
  scheduledLdt: string; // local datetime string (no Z suffix)
  calendarId?: number;
  isCompleted?: boolean;
  details?: TaskDetails;
  associationId?: number;
  associationType?: string;
}

export interface UpdateTaskEventDto {
  title?: string;
  scheduledLdt?: string; // local datetime string (no Z suffix)
  isCompleted?: boolean;
  details?: TaskDetails;
  associationId?: number;
  associationType?: string;
}

export const createTaskEvent = async (data: CreateTaskEventDto): Promise<CalendarEventDto> => {
  const response = await api.post<ApiResponse<CalendarEventDto>>('/calendars/events/task', data);
  return unwrapApiResponse<CalendarEventDto>(response);
};

export const updateTaskEvent = async (id: number, data: UpdateTaskEventDto): Promise<CalendarEventDto> => {
  const response = await api.patch<ApiResponse<CalendarEventDto>>(`/calendars/events/${id}/task`, data);
  return unwrapApiResponse<CalendarEventDto>(response);
};
